import { render, staticRenderFns } from "./IMModal.vue?vue&type=template&id=4858fd40&scoped=true"
import script from "./IMModal.vue?vue&type=script&lang=js"
export * from "./IMModal.vue?vue&type=script&lang=js"
import style0 from "./IMModal.vue?vue&type=style&index=0&id=4858fd40&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4858fd40",
  null
  
)

export default component.exports